export default "__VITE_ASSET__CcSJelHB__"